import NewCrawlForm from './NewCrawlForm';
import Lottie from 'lottie-react';
import LottieLoading from '@/assets/LottieLoading.json';
// هنگامی که خزشی انجام نشده نمایش داده میشود.
const NoCrawlData = (): React.JSX.Element => {
  return (
    <div className="justify-content-center align-items-center">
      <NewCrawlForm />
      <div
        className="mb-3 text-center"
        style={{ width: '250px', margin: 'auto' }}
      >
        <Lottie animationData={LottieLoading} />
      </div>
      <div className="mt-6 fw-medium text-center">
        برای شروع خزش، نشانی کامل رو وارد کن و دکمه خزش رو بزن.
      </div>
    </div>
  );
};

export default NoCrawlData;
